<template>
  <div id="app" class="main">
    <div class="content">
      <router-view />
      <div class="plugin-tools">
        <nav-menu-comp v-if="isDrawTool"></nav-menu-comp>
        <div id="DrawingTools"></div>
      </div>
    </div>
    <div class="weChat-wrapper">
      <we-chat />
    </div>
    <new-user-tutorials-comp />
    <div class="bottom-footer">
      <singleron-footer-comp v-if="!$route.meta.hideFooter" />
    </div>
    
  </div>
</template>
<script>
import SingleronFooterComp from "@/views/production/footer";
import navMenuComp from '@/components/nav/index.vue';
import { isCNSite } from "@/utils";
import weChat from "@/components/weChat";
import Tutorials from "@/components/Tutorials";
import mainApp from './main-app';
import { registerMicroApps, start } from 'qiankun';
export default {
  name: 'App',
  components: {
    SingleronFooterComp,
		'nav-menu-comp': navMenuComp,
    weChat,
    "new-user-tutorials-comp": Tutorials,
  },
  data() {
    return {
      isDrawTool: false,
    };
  },
  async created(){
    this.setI18nLanguage();
  },
  mounted() {
    const node = document.getElementById('DrawingTools');
    if (node) {
      registerMicroApps(mainApp, {
        beforeLoad: app => {
          console.log('before load app.name====>>>>>', app.name);
          this.isDrawTool = true;
        },
        beforeMount: [
          app => {
            console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name);
            this.isDrawTool = true;
          },
        ],
        afterMount: [
          app => {
            console.log('[LifeCycle] after mount %c%s', 'color: green;', app.name);
            this.isDrawTool = true;
          },
        ],
        afterUnmount: [
          app => {
            console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name);
            this.isDrawTool = false;
          },
        ],
      });
      start();
    }
  },
  methods:{
    setI18nLanguage() {
      const defaultLang = isCNSite() ?  'zh-CN' : 'en-US';
      document.querySelector('html').setAttribute('lang', defaultLang);
    },
  },
};
</script>
<style lang="scss" scoped>


.main {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1 0 100vh; // 940
}
.bottom-footer {
  flex: 0;
}
.plugin-tools {
  margin: auto;
  width: 85%;
}
</style>
